import { listPatients } from './index';

import { patientsRouteStore } from '../domain/store';

export default (number) => {
  patientsRouteStore.setValue('currentPage', number);
  return listPatients();
};
